<app-navigation style="box-shadow:none !important" class="pcoded-navbar"
                [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'theme-horizontal': this.config['layout'] === 'horizontal',
    'mob-open': navCollapsedMob
  }"
                (NavCollapse)="this.navCollapsed = !this.navCollapsed"
                (NavCollapsedMob)="navMobClick()"></app-navigation>
<app-nav-bar class="navbar pcoded-header navbar-expand-lg navbar-light" (NavCollapsedMob)="navMobClick()"></app-nav-bar>
<div class="pcoded-main-container" (click)="closeSidenav()">
  <div class="pcoded-wrapper">
    <div class="pcoded-content">
      <div class="pcoded-inner-content">
        <!--<app-breadcrumb></app-breadcrumb>-->
        <div class="main-body">
          <div class="page-wrapper">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
<app-configuration></app-configuration>

